import { LoginRoutingModule } from './login-routing.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { AvisosDialogService } from 'govbr-lib';
import { EsqueciMinhaSenhaModalComponent } from './esqueci-minha-senha-modal/esqueci-minha-senha-modal.component';
import { DirectiveModule } from 'src/app/directives/directive.module';


@NgModule({
  declarations: [
    LoginComponent,
    EsqueciMinhaSenhaModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    LoginRoutingModule,
    DirectiveModule
  ],
  providers: [
    AvisosDialogService,
  ],
  entryComponents: [
    EsqueciMinhaSenhaModalComponent
  ]
})
export class LoginModule { }
